import { useMutation, useQueryClient } from 'react-query';

import { getClient } from '@/lib/restClient';
import {
  MosPosImportResult,
  MosPosMenuMasterService,
} from '@/services/MosPosMenuMaster';

import { MOS_POS_MENU_MASTER_QUERY_KEY } from './useMosPosMenuMasterList';

export type ImportParams = {
  masterFile: File;
  relationFile: File;
};

/** 同じ2ファイルを再送信して登録します。成功したら一覧クエリを invalidate します。 */
export const useImportMosPosMenu = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, error, reset } = useMutation<
    MosPosImportResult,
    Error,
    ImportParams
  >(
    async ({ masterFile, relationFile }) => {
      const service = new MosPosMenuMasterService(getClient());
      return await service.runImport(masterFile, relationFile);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(MOS_POS_MENU_MASTER_QUERY_KEY);
      },
    }
  );

  return { runImport: mutateAsync, isImporting: isLoading, error, reset };
};
